import React, { Component }          from "react";
import { Button, Modal, PageHeader } from "react-bootstrap";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { invokeSetDeleteExercise }   from "../../utils/AwsInvoke";
import LoaderButton                  from "../../components/LoaderButton";
import "../../css/modal/ModalBasics.css";
//import "../../css/exercise/ExerciseList.css";

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class ExerciseDelete extends Component {
    constructor(props) {
        super(props);

        var exercise_id = `${this.props.match.params.exercise_id}`;

        this.state = {
              exerciseId: exercise_id,
              pageOverlay: "inline",
              showDeleteConfirmWin: true
        };
    }

    componentDidMount() {
        var that = this;
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            //this.deleteExercise()
        } catch (e) {
            alert(e);
        }
    }

    async deleteExercise () {

        var results = await invokeSetDeleteExercise(this.state.exerciseId);

        if(results.status) {
            this.props.history.goBack()
        } else
            this.props.history.goBack()
    }

    handleCloseWin = (action) => {
        this.setState({
            showDeleteConfirmWin: false
        });

        if(action === "delete") this.deleteExercise();
            else this.props.history.goBack()
    }


    render() {

        return (
            <div className="programs">
              <PageHeader>
                  <span style={{width:"220px"}}>
                      Exercises
                  </span>
              </PageHeader>

              <div>
                    <span className="pageOVerlay" style={{display:"inline"}}></span>
                    <Modal
                           show            = {this.state.showDeleteConfirmWin}
                           onHide          = {() => this.handleCloseWin("close")}
                           size            = "lg"
                           centered        = "true"
                           aria-labelledby = "contained-modal-title"
                           className       = "modalBasics"
                         >
                           <Modal.Header closeButton>
                             <Modal.Title id="contained-modal-title">
                                 <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                 <span className="modalBasicsTitle">
                                     Confirm Exercise Deletion
                                 </span>
                             </Modal.Title>
                           </Modal.Header>
                           <Modal.Body>
                               Are you sure you want to delete the exercise? test
                           </Modal.Body>
                           <Modal.Footer>
                               <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                               <span className="modalBasicsFooterXPosSpacer"/>
                               <LoaderButton
                                   bsSize    = "large"
                                   //disabled  = {!this.validateForm()}
                                   //type      = "submit"
                                   btncolor  = "#408fd2"
                                   height    = {38}
                                   width     = {80}
                                   isLoading = {this.state.isLoading}
                                   text        = "Ok"
                                   loadingText = "" //"Deleting program…"
                                   onClick     = {() => this.handleCloseWin("delete")}
                                 />
                           </Modal.Footer>
                     </Modal>
              </div>
            </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/exercise/ExerciseDelete.js